import { checkPathMatch } from '../../../shared/routing';

export const partnersCaddyPages = [
  'pages/ketone-iq-classic-6-shot-peach'
];

export const checkIsUpsellOnlyPage = () => checkPathMatch(partnersCaddyPages);
export const checkIsRegularCartPage = () => !checkPathMatch(partnersCaddyPages);
